export * from './src/loyalty-v1-coupon-coupons.universal.js';
